import { actionTypes } from "../actionTypes/actionTypes";
import { ADMIN } from "../../constants/admin";

interface IUserManagementState {
  userFormOpen: boolean;
  userFormType: string;
  selectedUserData: any | null;
  userTableData: any[] | null;
  userTableLoading: boolean;
}

const initialState: IUserManagementState = {
  userFormOpen: false,
  userFormType: ADMIN.MEETING_FORM_TYPE.CREATE,
  selectedUserData: null,
  userTableData: null,
  userTableLoading: false,
};

const userManagementReducer = (
  state: IUserManagementState = initialState,
  action: any
) => {
  switch (action.type) {
    case actionTypes.UPDATE_USER_FORM_OPEN:
      return {
        ...state,
        userFormOpen: action.payload,
      };
    case actionTypes.UPDATE_USER_FORM_TYPE:
      return {
        ...state,
        userFormType: action.payload,
      };
    case actionTypes.UPDATE_SELECTED_USER_DATA:
      return {
        ...state,
        selectedUserData: action.payload,
      };
    case actionTypes.UPDATE_USER_TABLE_DATA:
      return {
        ...state,
        userTableData: action.payload,
      };
    default:
      return state;
  }
};

export default userManagementReducer;

